export const FRANCHISE_BILLING = 'franchise/FRANCHISE_BILLING'
export const FRANCHISE_BILLING_SUCCESS = 'franchise/FRANCHISE_BILLING_SUCCESS'
export const FRANCHISE_BILLING_FAILURE = 'franchise/FRANCHISE_BILLING_FAILURE'
export const RESET_FRANCHISE_BILLING = 'franchise/RESET_FRANCHISE_BILLING'

export const ACTIVE_FRANCHISE_BILLING = 'franchise/ACTIVE_FRANCHISE_BILLING'
export const ACTIVE_FRANCHISE_BILLING_SUCCESS = 'franchise/ACTIVE_FRANCHISE_BILLING_SUCCESS'
export const ACTIVE_FRANCHISE_BILLING_FAILURE = 'franchise/ACTIVE_FRANCHISE_BILLING_FAILURE'
export const RESET_ACTIVE_FRANCHISE_BILLING = 'franchise/RESET_ACTIVE_FRANCHISE_BILLING'


// WEBPACK FOOTER //
// ./src/store/franchise/actionTypes.js